module.exports = __webpack_public_path__ + "img/Circuitdiagram1.d083c277.jpg";